export { default } from './ShareLinksProduct';